import actions from './actions'

const initialState = {
  detail: {},
  authorized: true,
  loading: false,
  formErrors: {},
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
